import Mutations from '../../odata/mutations';

export default { ...new Mutations('transactionPlayBook'), ...new Mutations('transactionPlayBooks') };
